import { useState } from "react";
import csc from "../../../src/assets/csc.png";
import UserIcon from "../../assets/user.svg";
import { useAuth } from "../../utils/hooks/useAuth";
import { getCourseIds } from "../../utils/getCourseIds";
import { draCourseIds } from "../../config";

type NavbarProps = {};

export function Navbar(props: NavbarProps) {
  const {
    authState: { vle },
  } = useAuth();

  const [showDropdown, setShowDropdown] = useState(false);
  const course_ids = getCourseIds();
  return (
    <header className="bg-white shadow-sm rounded-b-lg px-4 py-3 flex items-center justify-between">
      <div className="flex items-center space-x-4">
        {/* <img className="w-16" src={iibfLogo} alt="iibf" /> */}
        <h6 className="iibf-logo">
          {course_ids == draCourseIds
            ? "DRA Training Program"
            : "BC Training Program"}
        </h6>
        <img className="w-16" src={csc} alt="csc" />
      </div>

      <div className="hidden md:flex flex-grow mx-6 items-center justify-between text-sm">
        <div className="flex items-center space-x-6">
          <p className="text-blue-900 font-medium bg-[#EDF2FA] rounded-lg px-4 py-2 text-gray-600">
            VLE Name: <span className="font-semibold">{vle?.name}</span>
          </p>
          <p className="text-blue-900 font-medium bg-[#EDF2FA] rounded-lg px-4 py-2 text-gray-600">
            VLE ID: <span className="font-semibold">{vle?.cscId}</span>
          </p>
          <p className="text-blue-900 font-medium bg-[#EDF2FA] rounded-lg px-4 py-2 text-gray-600">
            State: <span className="font-semibold">{vle?.State?.name}</span>
          </p>
          <p className="text-blue-900 font-medium bg-[#EDF2FA] rounded-lg px-4 py-2 text-gray-600">
            District:{" "}
            <span className="font-semibold">{vle?.District?.name}</span>
          </p>
        </div>
      </div>

      <div className="relative">
        <div
          className="flex items-center space-x-2 cursor-pointer"
          onClick={() => setShowDropdown(!showDropdown)}
        >
          <span className="bg-gray-300 text-blue-900 font-semibold text-sm w-10 h-10 flex items-center justify-center rounded-full">
            <img src={UserIcon} className="m-2" />
          </span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 text-blue-900"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </div>

        {showDropdown && (
          <div className="md:hidden absolute top-14 right-2 bg-white shadow-md rounded-lg w-80 p-4 z-10">
            <p className="flex text-blue-900 font-medium mb-2">
              <span className="block font-bold">VLE Name:</span>
              {vle?.name}
            </p>
            <p className="flex text-blue-900 font-medium mb-2">
              <span className="block font-bold">VLE ID:</span>
              {vle?.cscId}
            </p>
            <p className="flex text-blue-900 font-medium mb-2">
              <span className="block font-bold">State:</span>
              {vle?.State?.name}
            </p>
            <p className="flex text-blue-900 font-medium mb-4">
              <span className="block font-bold">District:</span>
              {vle?.District?.name}
            </p>

            {/* <button
          onClick={logout}
          className="w-full rounded-md border hover:bg-blue-700 text-blue px-4 py-2 text-sm font-medium rounded-full"
        >
          Logout
        </button> */}
          </div>
        )}
      </div>
    </header>
  );
}
